"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverActivation = void 0;
const constants_1 = require("../constants");
const MouseEnvironmentActivation_1 = require("./MouseEnvironmentActivation");
class HoverActivation extends MouseEnvironmentActivation_1.MouseEnvironmentActivation {
    constructor(options) {
        super({ onIsActiveChanged: options.onIsActiveChanged });
        this.hoverDelayInMs = options.hoverDelayInMs;
        this.hoverOffDelayInMs = options.hoverOffDelayInMs;
    }
    mouseEntered() {
        this.clearTimers();
        this.schedulActivation(this.hoverDelayInMs);
    }
    mouseLeft() {
        this.clearTimers();
        this.scheduleDeactivation(this.hoverOffDelayInMs);
    }
    schedulActivation(schedule) {
        const scheduleId = setTimeout(() => {
            this.activate();
        }, schedule);
        this.timers.push({
            id: scheduleId,
            name: constants_1.SET_ACTIVATION_TIMER_NAME,
        });
    }
    scheduleDeactivation(schedule) {
        const scheduleId = setTimeout(() => {
            this.deactivate();
        }, schedule);
        this.timers.push({
            id: scheduleId,
            name: constants_1.UNSET_ACTIVATION_TIMER_NAME,
        });
    }
}
exports.HoverActivation = HoverActivation;
//# sourceMappingURL=HoverActivation.js.map